export default [{
  path: '/home',
  name: 'home',
  component: () => import('@/pages/home/index'),
  meta: {
    spm: 2274,
  },
},
];
